export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "时间", prop: "createTime",width:200 },
    { label: "类型", prop: "userType" },
    { label: "公司名", prop: "fairTitle", width: 200 },
    { label: "姓名", prop: "name" },
    // { label: "职务", prop: "job" },
    {
      label: "手机号",
      prop: "phone",
      width: 150,
    },
    {
      label: "操作",
      prop: "operation",
      width: 220,
      slots: "operation",
      fixed: "right",
    },
  ];
}
